import React from 'react';

import './styles/tokens.css';
import './styles/base.css';
import './styles/nav.css';
import './styles/hero.css';
import './styles/statement.css';
import './styles/companies.css';
import './styles/process.css';
import './styles/advantages.css';
import './styles/contact.css';

import { AnimationProvider } from './components/primitives/Motion';
import ScrollProgress from './components/ScrollProgress';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Manifesto from './components/Manifesto';
import Companies from './components/Companies';
import Process from './components/Process';
import Advantages from './components/Advantages';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
    return (
        <AnimationProvider>
            <ScrollProgress />
            <Nav />

            <main>
                <Hero />
                <Marquee />
                <Manifesto />
                <Companies />
                <Process />
                <Advantages />
                <Contact />
            </main>

            <Footer />
            <div className="grain" aria-hidden="true" />
        </AnimationProvider>
    );
}
